export enum SetupFields {
    Practice = "practice",
    Status = "status"
}